"use client";

import Link from "next/link";
import {
  COMPANY_EMAIL,
  COMPANY_LOCATION,
  COMPANY_PHONE_TEXT,
  PATIENT_RESOURCES_PAYMENTS,
  PA_RESIDENCY_TRAINING_PROGRAM,
  SCHEDULE_A_PROCEDURE,
} from "../../utils/constants";
import { Field, Formik, Form } from "formik";
import * as Yup from "yup";
import { useState } from "react";
import CustomButton from "./CustomButton";
import { OUR_SERVICES_LINKS, QUICK_NAVIGATION, SITE_LINKS } from "../../data/FooterAndHeader";
import { stringify } from "querystring";
import PopUpModal from "./PopUpModal";
import { SuccessfulPage } from "./SuccessfulPage";
import Loading from "../../app/loading";

export const FooterLinks = () => {
  return (
    <div className="links">
      {QUICK_NAVIGATION.map((item, index) => (
        <div key={index} className="flex center-left">
          <div className="logo">
            {item.disabled ? (
              <div className="flex center-center font-mont cursor-default opacity-60 no-hover">
                <div className="flex mar-12">{item.icon}</div>
                <span className="color-light-grey l-h-1-5 flex-1 p-18 f-w-300 font-montserrat">{item.description}</span>
              </div>
            ) : (
            <Link href={item.link} className="flex center-center font-mont">
                <div className="flex mar-12">{item.icon}</div>
                <span className="color-light-grey l-h-1-5 flex-1 p-18 f-w-300 font-montserrat transition hover-color-blue hover-text-underline">
                  {item.description}
                </span>
              </Link>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export const SiteLink = () => {
  return (
    <div className="links ">
      {SITE_LINKS.map((item, index) => (
        <Link key={index} href={item.link} className=" flex center-center font-mont mar-b-12">
          <span className="color-light-grey medium l-h-1-5 flex-1 p-18 f-w-300 font-montserrat transition hover-color-purple hover-text-underline">
            {item.name}
          </span>
        </Link>
      ))}
    </div>
  );
};

export const OurServices = () => {
  return (
    <div className="links">
      {OUR_SERVICES_LINKS.map((item, index) => (
        <Link key={index} href={item.link} className=" flex center-center font-mont mar-b-12">
          <span className="color-light-grey medium l-h-1-5 flex-1 p-18 f-w-300 font-montserrat transition hover-color-purple hover-text-underline">
            {item.name}
          </span>
        </Link>
      ))}
    </div>
  );
};

export const ContactUsForm = () => {
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState({
    title: "",
    message: "",
    status: "",
  });

  const initialValues = {
    name: "",
    email: "",
  };

  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Name is required"),
    email: Yup.string().email().required("Email is required"),
  });

  const onSubmit = async (values, { resetForm }) => {
    console.log("Values", values);
    setLoading(true);

    try {
      const response = await fetch("/api/subscribe", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(values),
      });

      const api = await response.json();
      console.log("Response from API", api);

      if (response.ok) {
        setModalData({
          title: "Successful!",
          message: "Thank you for Subscribing.",
          status: "success",
        });
        resetForm();
      } else {
        console.log(`Error: ${api.error || "Something went wrong"}`);
        setModalData({
          title: "Error!",
          message: api.error || "Something went wrong",
          status: "err",
        });
      }
    } catch (error) {
      setModalData({
        title: "Sorry :(",
        message: "An unexpected error occurred. Please try again.",
        status: "err",
      });
    } finally {
      setLoading(false);
      setShowModal(true);
    }
  };

  return (
    <>
      <div className="form">
        <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={onSubmit}>
          {({ values, errors, touched }) => (
            <Form>
              <div className="footer-form">
                <div className=" field">
                  <Field name="name" type="text" placeholder="Name" className={`field-box ${errors.name && touched.name ? "error" : ""}`} />
                </div>
                <div className="field">
                  <Field name="email" type="email" placeholder="Email" className={`field-box ${errors.name && touched.name ? "error" : ""}`} />
                </div>

                <div className="btn" style={{ marginBottom: 10 }}>
                  <button
                    style={{ height: 40, paddingLeft: 20, paddingRight: 20, letterSpacing: 1 }}
                    type="submit"
                    className="flex center-center "
                    disabled={loading || !values.name || !values.email}
                  >
                    {loading ? "Sending..." : "Send"}
                  </button>
                </div>

                <div className="logo">
                  <Link
                    href="/"
                    // onClick={() => {
                    //   setTimeout(() => setNavMenu(false), 300);
                    // }}
                  >
                    <div className="flex center-left">
                      <img src="/images/header/Link.png" alt="icon" height="70px" />
                    </div>
                  </Link>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
      {showModal && (
        <PopUpModal onClose={() => setShowModal(false)}>
          <SuccessfulPage modalData={modalData} onClose={() => setShowModal(false)} />
        </PopUpModal>
      )}
    </>
  );
};
